module.exports = __webpack_public_path__ + "img/199.bd861653.png";